import React from 'react'
import cx from 'classnames'

interface SvgProps {
  className?: string
  heightOverride?: string
}

// export const Logo = ({ className }: SvgProps) => (
//   <svg className={cx('block', className)} viewBox="0 0 100 61" fill="none">
//     <path
//       d="M0 3.36011V18.6384H2.17392C2.17392 11.3592 7.99691 5.83984 15.1398 5.83984H18.323V47.8352C18.323 53.0347 13.587 57.2742 8.85095 57.2742V59.434H36.1025V57.2742C31.3665 57.2742 26.6305 53.0347 26.6305 47.8352V5.75984H30.2796C32.0653 5.75984 33.7733 6.07981 35.4038 6.79973C35.792 5.59986 36.4131 4.39999 37.1895 3.36011H0Z"
//       fill="white"
//     />
//     <path
//       d="M51.5527 49.8348V34.4765C51.5527 32.1568 53.3384 30.237 55.59 30.237H55.6676V28.2372H43.2453V52.9545C43.2453 55.2742 42.0807 57.194 39.6738 57.194V59.3538H58.6179V57.194C54.503 57.194 51.5527 53.9144 51.5527 49.8348Z"
//       fill="white"
//     />
//     <path
//       d="M92.9353 49.8341V34.4758C92.9353 32.156 94.721 30.3162 96.9726 30.2362H97.0502V28.2364H84.6278V29.9163C79.8918 26.4766 74.1465 25.4367 68.5564 27.7565C60.0936 31.5961 56.2893 41.755 60.0936 50.474C63.6651 58.7131 72.7489 62.7126 80.9788 59.673C82.2986 59.113 83.7738 58.4731 84.6278 57.5132V59.273H100.001V57.1133C95.8856 57.1933 92.9353 53.9136 92.9353 49.8341ZM80.3576 57.6732C75.7769 59.593 69.6433 54.8735 66.693 47.2743C63.7427 39.6752 64.9849 31.916 69.5657 29.9962C74.1465 28.0765 80.28 32.7959 83.2303 40.3951C86.2583 47.9943 84.9384 55.7534 80.3576 57.6732Z"
//       fill="white"
//     />
//     <path
//       d="M47.5942 0C41.6159 0 36.7246 5.03945 36.7246 11.1988C36.7246 17.3581 41.6159 22.3975 47.5942 22.3975C53.5725 22.3975 58.4638 17.3581 58.4638 11.1988C58.3861 5.03945 53.5725 0 47.5942 0C47.6718 0 47.5942 0 47.5942 0Z"
//       fill="#EF308D"
//       className="logo__dot"
//     />
//   </svg>
// )

export const Logo = ({ className }: SvgProps) => (
  <svg
    width="223"
    className={cx('block', className)}
    height="134"
    viewBox="0 0 223 134"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_9_3060)">
      <path
        className="svg-circle"
        d="M94.7303 38.3C106.24 38.3 114.43 30.11 114.43 19.26C114.43 9.08 106.24 0 94.7303 0C83.2203 0 75.0303 9.07 75.0303 19.26C75.0303 30.11 83.2203 38.3 94.7303 38.3Z"
        fill="#EF308D"
      />
      <path
        d="M220.37 116.329C218.37 118.829 216.28 120.749 213.95 120.749C209.77 120.749 207.79 118.189 207.79 112.669V75.0393C207.79 52.2793 193.27 42.7293 167.97 43.5793C160.44 43.8293 149.74 45.2593 134.18 50.0993V77.5593H137.92C148.1 57.5293 159.98 52.2093 167.07 50.9393C175.66 49.4093 180.68 54.1893 180.68 62.6993V84.0493H160.94C141.53 84.0493 128.49 91.9193 128.49 108.819C128.49 122.709 139.2 133.619 155.09 133.619C169.64 133.619 179.35 124.199 181.35 115.669C183.46 129.989 194.4 133.619 201.59 133.619C210.45 133.619 218.48 128.279 222.83 118.069L220.37 116.329ZM180.7 100.929C180.7 111.689 175.21 116.079 168.68 116.079C162.15 116.079 156.53 111.869 156.53 104.369C156.53 97.5393 159.76 92.1293 172.64 90.4693L180.71 89.7093V100.929H180.7Z"
        fill="#fff"
      />
      <path
        d="M110.2 104.001V69.0309L110.37 48.2009H38.3V20.2109H34.07C34.07 20.2109 29.73 45.1909 0 51.2309V55.3909H10.54V105.011C10.54 123.751 22.59 133.621 37.48 133.621C52.37 133.621 60.04 124.451 63.57 112.401L60.65 111.431C58.34 115.771 53.79 117.491 49.03 117.491C42.67 117.491 38.32 112.301 38.32 104.431V55.3809H72.21C80.82 55.3809 82.44 59.7409 82.44 69.0009V103.971C82.44 121.411 77.91 122.351 70.24 127.921V131.301H122.43V127.951C114.76 122.391 110.23 121.441 110.23 104.001H110.2Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_3060">
        <rect width="222.83" height="133.61" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const NewLogo = ({ className, heightOverride }: SvgProps) => (
  <svg
    width="149"
    height={heightOverride || '30'}
    viewBox="0 0 149 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5588 8.65119C23.0281 8.65119 24.7852 6.90231 24.7852 4.58541C24.7852 2.41159 23.0281 0.472656 20.5588 0.472656C18.0895 0.472656 16.3324 2.40945 16.3324 4.58541C16.3324 6.90231 18.0895 8.65119 20.5588 8.65119Z"
      fill="white"
    />
    <path
      d="M47.8864 25.3901C47.4491 25.9262 46.992 26.3379 46.4825 26.3379C45.5684 26.3379 45.1354 25.7889 45.1354 24.6053V16.5363C45.1354 11.656 41.9601 9.60816 36.4274 9.79043C34.7808 9.84404 32.4408 10.1507 29.0381 11.1885V17.0767H29.856C32.0822 12.7817 34.6802 11.6409 36.2306 11.3686C38.1091 11.0405 39.2069 12.0655 39.2069 13.8903V18.4683H34.8901C30.6455 18.4683 27.7938 20.1559 27.7938 23.7797C27.7938 26.7581 30.1359 29.0975 33.6108 29.0975C36.7926 29.0975 38.916 27.0776 39.3534 25.2486C39.8148 28.3192 42.2072 29.0975 43.7796 29.0975C45.7171 29.0975 47.4731 27.9525 48.4244 25.7632L47.8864 25.3901ZM39.2113 22.0879C39.2113 24.3951 38.0107 25.3365 36.5827 25.3365C35.1547 25.3365 33.9257 24.4337 33.9257 22.8255C33.9257 21.361 34.632 20.2009 37.4487 19.845L39.2135 19.682V22.0879H39.2113Z"
      fill="white"
    />
    <path
      d="M23.9857 22.763V15.2844L24.0227 10.8297H8.33616V4.84387H7.41547C7.41547 4.84387 6.47084 10.186 -0.00012207 11.4777V12.3674H2.29399V22.979C2.29399 26.9867 4.91676 29.0974 8.15769 29.0974C11.3986 29.0974 13.068 27.1364 13.8364 24.5594L13.2008 24.3519C12.698 25.2801 11.7077 25.6479 10.6716 25.6479C9.28733 25.6479 8.34052 24.538 8.34052 22.8549V12.3652H15.7169C17.591 12.3652 17.9436 13.2977 17.9436 15.278V22.7566C17.9436 26.4862 16.9576 26.6873 15.2881 27.8785V28.6013H26.6477V27.8849C24.9783 26.6958 23.9923 26.4927 23.9923 22.763H23.9857Z"
      fill="white"
    />
    <path
      d="M54.4015 28.5273V4.70046H57.2608V15.0822H69.3784V4.70046H72.2377V28.5273H69.3784V17.6691H57.2608V28.5273H54.4015ZM83.8658 29.0039C79.2365 29.0039 75.4923 25.3277 75.4923 20.0858C75.4923 14.8439 79.2706 11.1678 84.0019 11.1678C88.9715 11.1678 92.1031 14.6737 92.1031 19.6093V20.5283H78.1814C78.3515 23.9662 80.564 26.6552 83.9679 26.6552C86.8612 26.6552 88.529 25.0895 89.5842 22.877L91.6265 24.0683C90.0608 27.2339 87.644 29.0039 83.8658 29.0039ZM78.1814 18.3158H89.346C89.1758 15.0822 86.725 13.3803 83.9679 13.3803C81.0406 13.3803 78.726 15.5247 78.1814 18.3158ZM100.114 29.0039C96.6764 29.0039 94.4639 26.8595 94.4639 23.83C94.4639 20.5283 97.153 18.8604 100.216 18.3839L105.935 17.4649V16.682C105.935 14.4695 104.471 13.3462 101.952 13.3462C99.2974 13.3462 97.9359 14.6737 97.9359 16.1033C97.9359 16.2395 97.9359 16.3076 98.0039 16.5799L95.6553 17.3627C95.4851 16.9883 95.383 16.4777 95.383 16.0352C95.383 13.4143 98.038 11.1678 101.952 11.1678C106.275 11.1678 108.658 13.2101 108.658 16.7501V24.3066C108.658 26.2468 108.896 27.2339 109.713 28.5273H106.956C106.514 28.0168 105.969 26.9275 105.969 25.1916C105.05 27.4722 102.599 29.0039 100.114 29.0039ZM100.557 26.6212C103.961 26.6212 105.935 23.5237 105.935 20.256V19.5752L100.761 20.4262C98.4805 20.8006 97.187 21.992 97.187 23.7279C97.187 25.4639 98.5145 26.6212 100.557 26.6212ZM112.516 28.5273V4.70046H115.239V28.5273H112.516ZM125.234 29.0039C122.817 29.0039 120.775 27.6764 120.775 24.2045V13.7887H117.916V11.6443H120.775V7.08315H123.532V11.6443H127.548V13.7887H123.532V24.0002C123.532 25.7702 124.315 26.5872 125.847 26.5872C126.323 26.5872 126.834 26.485 127.174 26.3829L127.412 28.6635C126.834 28.8677 126.119 29.0039 125.234 29.0039ZM130.501 28.5273V4.70046H133.224V14.7418C134.483 12.5293 136.73 11.1678 139.316 11.1678C142.959 11.1678 145.239 13.3803 145.239 17.0904V28.5273H142.482V17.7712C142.482 15.1162 140.882 13.6526 138.397 13.6526C135.742 13.6526 133.224 16.0352 133.224 19.4391V28.5273H130.501Z"
      fill="white"
    />
  </svg>
)

export const LogoDark = ({ className, heightOverride }: SvgProps) => (
  <svg
    width="156"
    height={heightOverride || '30'}
    viewBox="0 0 156 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5466 8.57143C24.1346 8.57143 25.9761 6.73853 25.9761 4.31033C25.9761 2.03208 24.1346 0 21.5466 0C18.9587 0 17.1172 2.02984 17.1172 4.31033C17.1172 6.73853 18.9587 8.57143 21.5466 8.57143Z"
      fill="#282725"
    />
    <path
      d="M50.1871 26.1146C49.7287 26.6764 49.2497 27.1079 48.7157 27.1079C47.7577 27.1079 47.3039 26.5326 47.3039 25.2921V16.8355C47.3039 11.7206 43.9761 9.57448 38.1776 9.7655C36.4518 9.82168 33.9995 10.143 30.4333 11.2307V17.4018H31.2905C33.6236 12.9005 36.3464 11.7049 37.9713 11.4195C39.9401 11.0757 41.0906 12.1499 41.0906 14.0623V18.8603H36.5664C32.1178 18.8603 29.1292 20.6289 29.1292 24.4269C29.1292 27.5483 31.5838 30.0001 35.2256 30.0001C38.5603 30.0001 40.7858 27.8832 41.2441 25.9662C41.7277 29.1844 44.235 30.0001 45.8829 30.0001C47.9135 30.0001 49.7539 28.8001 50.7509 26.5056L50.1871 26.1146ZM41.0952 22.6537C41.0952 25.0718 39.8369 26.0584 38.3403 26.0584C36.8437 26.0584 35.5557 25.1123 35.5557 23.4268C35.5557 21.8919 36.2959 20.6761 39.2479 20.3031L41.0975 20.1323V22.6537H41.0952Z"
      fill="#282725"
    />
    <path
      d="M25.1382 23.3614V15.5236L25.1769 10.8549H8.73677V4.58147H7.77184C7.77184 4.58147 6.78183 10.1803 0 11.534V12.4664H2.40432V23.5878C2.40432 27.788 5.1531 30.0002 8.54971 30.0002C11.9463 30.0002 13.696 27.9449 14.5012 25.2441L13.8351 25.0267C13.3082 25.9995 12.2703 26.385 11.1844 26.385C9.73363 26.385 8.74133 25.2217 8.74133 23.4578V12.4642H16.4721C18.4362 12.4642 18.8057 13.4414 18.8057 15.5168V23.3547C18.8057 27.2636 17.7724 27.4742 16.0227 28.7227V29.4802H27.928V28.7294C26.1784 27.4832 25.145 27.2703 25.145 23.3614H25.1382Z"
      fill="#282725"
    />
    <path
      d="M57.0318 30.1056V4.99256H60.0454V15.9346H72.8171V4.99256H75.8307V30.1056H72.8171V18.6612H60.0454V30.1056H57.0318ZM88.0865 30.6078C83.2074 30.6078 79.261 26.7332 79.261 21.2084C79.261 15.6835 83.2432 11.8089 88.23 11.8089C93.4678 11.8089 96.7684 15.5041 96.7684 20.7061V21.6748H82.0952C82.2746 25.2982 84.6065 28.1324 88.1941 28.1324C91.2435 28.1324 93.0014 26.4821 94.1136 24.1502L96.2661 25.4058C94.6158 28.7423 92.0687 30.6078 88.0865 30.6078ZM82.0952 19.3428H93.8625C93.6831 15.9346 91.1 14.1409 88.1941 14.1409C85.1088 14.1409 82.6692 16.401 82.0952 19.3428ZM105.212 30.6078C101.589 30.6078 99.2567 28.3476 99.2567 25.1547C99.2567 21.6748 102.091 19.9169 105.32 19.4146L111.347 18.4459V17.6208C111.347 15.2889 109.804 14.105 107.149 14.105C104.351 14.105 102.916 15.5041 102.916 17.0109C102.916 17.1544 102.916 17.2262 102.988 17.5132L100.512 18.3383C100.333 17.9437 100.225 17.4056 100.225 16.9392C100.225 14.1767 103.024 11.8089 107.149 11.8089C111.706 11.8089 114.217 13.9615 114.217 17.6926V25.657C114.217 27.7019 114.468 28.7423 115.329 30.1056H112.423C111.957 29.5674 111.383 28.4194 111.383 26.5897C110.414 28.9934 107.831 30.6078 105.212 30.6078ZM105.678 28.0965C109.266 28.0965 111.347 24.8318 111.347 21.3878V20.6702L105.894 21.5671C103.49 21.9618 102.127 23.2174 102.127 25.0471C102.127 26.8767 103.526 28.0965 105.678 28.0965ZM118.283 30.1056V4.99256H121.153V30.1056H118.283ZM131.688 30.6078C129.14 30.6078 126.988 29.2087 126.988 25.5493V14.5714H123.974V12.3112H126.988V7.50386H129.894V12.3112H134.127V14.5714H129.894V25.3341C129.894 27.1996 130.719 28.0606 132.333 28.0606C132.836 28.0606 133.374 27.953 133.732 27.8454L133.984 30.2491C133.374 30.4643 132.62 30.6078 131.688 30.6078ZM137.238 30.1056V4.99256H140.108V15.5759C141.436 13.244 143.804 11.8089 146.53 11.8089C150.369 11.8089 152.773 14.1409 152.773 18.0513V30.1056H149.867V18.7688C149.867 15.9705 148.181 14.4279 145.562 14.4279C142.763 14.4279 140.108 16.9392 140.108 20.5267V30.1056H137.238Z"
      fill="#282725"
    />
  </svg>
)

export const ShapeOne = ({ className }: SvgProps) => (
  <svg className={cx('block', className)} viewBox="0 0 1280 30" fill="none">
    <path
      d="M2.62268e-06 30.0001L1280 30L1280 0C1280 0 1084.58 13.8806 914.643 13.8806C744.709 13.8806 533.792 6.52356e-05 363.858 8.00917e-05C193.924 9.49478e-05 1.21348e-06 13.8807 1.21348e-06 13.8807L2.62268e-06 30.0001Z"
      fill="currentColor"
    />
  </svg>
)

export const ShapeTwo = ({ className }: SvgProps) => (
  <svg className={cx('block', className)} viewBox="0 0 1280 72" fill="none">
    <path
      d="M1280 71L1280 4.70043C662 104.425 463.035 -25.6055 0 4.70034V71C0 71 146.362 72.4279 385.419 71C624.476 69.5721 803.659 71 990.381 71H1280Z"
      fill="currentColor"
    />
  </svg>
)

export const ShapeThree = ({ className }: SvgProps) => (
  <svg className={cx('block', className)} viewBox="0 0 1280 30" fill="none">
    <path
      d="M0 13.8806V30L640 30L1280 30V0C1280 0 1084.58 13.8806 914.643 13.8806C744.709 13.8806 533.792 0 363.858 0C193.924 0 0 13.8806 0 13.8806Z"
      fill="currentColor"
    />
  </svg>
)

export const ShapeFour = ({ className }: SvgProps) => (
  <svg className={cx('block', className)} viewBox="0 0 1280 62" fill="none">
    <path
      d="M1280 32.9851V62.0001H640H0V8.00006C0 8.00006 195.424 42.0001 365.357 42.0001C535.291 42.0001 746.208 0 916.142 0C1086.08 0 1280 32.9851 1280 32.9851Z"
      fill="currentColor"
    />
  </svg>
)

export const CtaShape = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="213"
    height="48"
    viewBox="0 0 213 48"
    fill="none"
  >
    <path
      d="M153.598 47.0012C140.773 47.0012 134.365 37.5097 128.162 28.341C121.951 19.1453 116.081 10.4695 104.214 10.4695C92.3477 10.4695 86.4772 19.1543 80.2661 28.341C74.0639 37.5187 67.6557 47.0012 54.8301 47.0012C42.0135 47.0012 35.5963 37.5097 29.3942 28.341C23.1831 19.1453 17.3125 10.4695 5.446 10.4695C-6.42053 10.4695 -12.2911 19.1543 -18.5022 28.341C-24.7043 37.5187 -31.1126 47.0012 -43.9292 47.0012C-56.7457 47.0012 -63.163 37.5097 -69.3562 28.341C-75.5673 19.1453 -81.4378 10.4695 -93.3043 10.4695C-105.171 10.4695 -111.041 19.1543 -117.253 28.341C-123.455 37.5187 -129.863 47.0012 -142.688 47.0012C-155.505 47.0012 -161.922 37.5097 -168.115 28.341C-174.318 19.1453 -180.188 10.4605 -192.055 10.4605V8.66797C-179.238 8.66797 -172.821 18.1594 -166.628 27.3282C-160.417 36.5238 -154.546 45.1997 -142.68 45.1997C-130.813 45.1997 -124.942 36.5149 -118.731 27.3282C-112.529 18.1504 -106.121 8.66797 -93.2954 8.66797C-80.4788 8.66797 -74.0616 18.1594 -67.8684 27.3282C-61.6573 36.5238 -55.7867 45.1997 -43.9202 45.1997C-32.0537 45.1997 -26.1832 36.5149 -19.972 27.3282C-13.7699 18.1504 -7.36162 8.66797 5.45496 8.66797C18.2715 8.66797 24.6888 18.1594 30.8909 27.3282C37.102 36.5238 42.9726 45.1997 54.8391 45.1997C66.7056 45.1997 72.5761 36.5149 78.7873 27.3282C84.9894 18.1504 91.3977 8.66797 104.223 8.66797C117.049 8.66797 123.457 18.1594 129.659 27.3282C135.87 36.5238 141.741 45.1997 153.607 45.1997C165.474 45.1997 171.344 36.5149 177.556 27.3282C183.758 18.1504 190.166 8.66797 202.991 8.66797V10.4605C191.125 10.4605 185.254 19.1453 179.043 28.332C172.832 37.5097 166.424 47.0012 153.598 47.0012Z"
      fill="#FFF8EF"
      stroke="white"
    />
    <path
      d="M5.46157 19.1263C10.7406 19.1263 15.0247 14.8421 15.0247 9.56314C15.0247 4.28414 10.7406 0 5.46157 0C0.182577 0 -4.10156 4.28414 -4.10156 9.56314C-4.10156 14.8421 0.182577 19.1263 5.46157 19.1263Z"
      fill="#EF308D"
    />
    <path
      d="M81.1022 37.3919C86.3812 37.3919 90.6653 33.1078 90.6653 27.8288C90.6653 22.5498 86.3812 18.2656 81.1022 18.2656C75.8232 18.2656 71.5391 22.5498 71.5391 27.8288C71.5391 33.1167 75.8232 37.3919 81.1022 37.3919Z"
      fill="#EF308D"
    />
    <path
      d="M202.985 19.1263C208.264 19.1263 212.548 14.8421 212.548 9.56314C212.548 4.28414 208.264 0 202.985 0C197.706 0 193.422 4.28414 193.422 9.56314C193.422 14.8421 197.706 19.1263 202.985 19.1263Z"
      fill="#EF308D"
    />
  </svg>
)

export const CtaBoobs = ({ className }: SvgProps) => (
  <svg
    width="151"
    height="186"
    viewBox="0 0 151 186"
    fill="none"
    className={cx('block', className)}
  >
    <path
      d="M78.7011 62.68C61.9411 62.68 48.3611 49.09 48.3611 32.34C48.3611 15.58 61.9511 2.00001 78.7011 2.00001L277.871 2.00002"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinejoin="bevel"
    />
    <path
      d="M78.7 62.68L236.66 62.6801C253.42 62.6801 267 76.2701 267 93.0201C267 109.78 253.41 123.36 236.66 123.36"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinejoin="bevel"
    />
    <path
      d="M298.48 184.06L41.6105 184.06C24.8505 184.06 11.2705 170.47 11.2705 153.72C11.2705 136.96 24.8605 123.38 41.6105 123.38L236.66 123.38"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinejoin="bevel"
    />
    <path
      d="M36.9606 32.33C36.9606 38.869 42.2616 44.17 48.8006 44.17C55.3397 44.17 60.6406 38.869 60.6406 32.33C60.6406 25.7909 55.3397 20.49 48.8006 20.49C42.2616 20.49 36.9606 25.7909 36.9606 32.33Z"
      fill="#EF308D"
    />
    <path
      d="M0.00189158 155.95C0.0018913 162.417 5.24463 167.66 11.7119 167.66C18.1791 167.66 23.4219 162.417 23.4219 155.95C23.4219 149.483 18.1791 144.24 11.7119 144.24C5.24463 144.24 0.00189186 149.483 0.00189158 155.95Z"
      fill="#EF308D"
    />
  </svg>
)

export const Location = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="35"
    height="36"
    viewBox="0 0 35 36"
    fill="none"
  >
    <path
      d="M7.16602 30.9001C7.16602 31.6885 7.81102 32.3335 8.59935 32.3335H25.7994C26.5877 32.3335 27.2327 31.6885 27.2327 30.9001C27.2327 30.1118 26.5877 29.4668 25.7994 29.4668H8.59935C7.81102 29.4668 7.16602 30.1118 7.16602 30.9001Z"
      fill="#8C8C8C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1991 3.64062C12.358 3.64062 8.41992 7.57871 8.41992 12.4198C8.41992 17.6497 13.9633 24.8611 16.2459 27.6077C16.7476 28.2097 17.6631 28.2097 18.1648 27.6077C20.4348 24.8611 25.9783 17.6497 25.9783 12.4198C25.9783 7.57871 22.0402 3.64062 17.1991 3.64062ZM17.2 6.1491C18.5796 6.1491 19.7083 7.27786 19.7083 8.65744C19.7083 10.0496 18.5796 11.1658 17.2 11.1658C15.8204 11.1658 14.6917 10.0496 14.6917 8.65744C14.6917 7.27786 15.8204 6.1491 17.2 6.1491ZM12.1833 15.9939C13.2619 17.6243 15.1055 18.6903 17.2 18.6903C19.2945 18.6903 21.1381 17.6243 22.2167 15.9939C22.1916 14.3384 18.868 13.4229 17.2 13.4229C15.532 13.4229 12.2084 14.3384 12.1833 15.9939Z"
      fill="#8C8C8C"
    />
  </svg>
)

export const LocationVirtual = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.53412 10.8332C6.53412 10.0449 7.17912 9.39987 7.96745 9.39987H30.9008C31.6891 9.39987 32.3341 8.75487 32.3341 7.96654C32.3341 7.1782 31.6891 6.5332 30.9008 6.5332H6.53412C4.95745 6.5332 3.66745 7.8232 3.66745 9.39987V25.1665H2.95078C1.76111 25.1665 0.800781 26.1269 0.800781 27.3165C0.800781 28.5062 1.76111 29.4665 2.95078 29.4665H18.7175C19.9071 29.4665 20.8675 28.5062 20.8675 27.3165C20.8675 26.1269 19.9071 25.1665 18.7175 25.1665H6.53412V10.8332ZM33.7667 12.2667H25.1667C24.3783 12.2667 23.7333 12.9117 23.7333 13.7V28.0333C23.7333 28.8217 24.3783 29.4667 25.1667 29.4667H33.7667C34.555 29.4667 35.2 28.8217 35.2 28.0333V13.7C35.2 12.9117 34.555 12.2667 33.7667 12.2667ZM26.6 25.1667H32.3333V15.1333H26.6V25.1667Z"
      fill="#8C8C8C"
    />
    <path
      d="M15.1342 12.2666C16.7109 12.2666 18.0009 13.5566 18.0009 15.1333C18.0009 16.7099 16.7109 17.9999 15.1342 17.9999C13.5576 17.9999 12.2676 16.7099 12.2676 15.1333C12.2676 13.5566 13.5576 12.2666 15.1342 12.2666Z"
      fill="#8C8C8C"
    />
    <path
      d="M20.8671 23.7331H9.40039V22.2998C9.40039 20.3934 13.2274 19.4331 15.1337 19.4331C17.0401 19.4331 20.8671 20.3934 20.8671 22.2998V23.7331Z"
      fill="#8C8C8C"
    />
  </svg>
)

export const LocationClinic = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="35"
    height="36"
    viewBox="0 0 35 36"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8001 7.96676V10.8334H29.2668C30.8435 10.8334 32.1335 12.1234 32.1335 13.7001V28.0334C32.1335 29.6101 30.8435 30.9001 29.2668 30.9001H6.33346C4.7568 30.9001 3.4668 29.6101 3.4668 28.0334V7.96676C3.4668 6.3901 4.7568 5.1001 6.33346 5.1001H14.9335C16.5101 5.1001 17.8001 6.3901 17.8001 7.96676ZM6.33333 28.0333H9.2V25.1667H6.33333V28.0333ZM9.2 22.3H6.33333V19.4333H9.2V22.3ZM6.33333 16.5667H9.2V13.7H6.33333V16.5667ZM9.2 10.8333H6.33333V7.96667H9.2V10.8333ZM12.0667 28.0333H14.9333V25.1667H12.0667V28.0333ZM14.9333 22.3H12.0667V19.4333H14.9333V22.3ZM12.0667 16.5667H14.9333V13.7H12.0667V16.5667ZM14.9333 10.8333H12.0667V7.96667H14.9333V10.8333ZM17.8 28.0333H27.8333C28.6217 28.0333 29.2667 27.3883 29.2667 26.6V15.1333C29.2667 14.345 28.6217 13.7 27.8333 13.7H17.8V16.5667H20.6667V19.4333H17.8V22.3H20.6667V25.1667H17.8V28.0333ZM26.4 16.5667H23.5333V19.4333H26.4V16.5667ZM23.5333 22.3H26.4V25.1667H23.5333V22.3Z"
      fill="#8C8C8C"
    />
  </svg>
)

export const JoinShape = ({ className }: SvgProps) => (
  <svg className={cx('block', className)} viewBox="0 0 148 72" fill="none">
    <path
      d="M148 36L137.735 37.6341L145.066 46.7783L135.473 41.5692L139.587 53.5481L131.418 45.3643L133.629 58.1236L126.498 48.5425L127.518 61.5418L121.147 51.1604L121.324 64.2231L115.548 53.318L115.079 66.3707L109.795 55.0822L108.802 68.0882L103.944 56.5095L102.501 69.4522L98.0234 57.6334L96.1818 70.4993L92.057 58.4837L89.8541 71.2597L86.0558 59.0774L83.513 71.7566L80.036 59.4275L77.1719 72L74 59.5442L70.8281 72L67.9667 59.4275L64.487 71.7566L61.9468 59.0774L58.1513 71.2597L55.9457 58.4837L51.8182 70.4993L49.9766 57.6334L45.4985 69.4522L44.0531 56.5095L39.1949 68.0882L38.2018 55.0822L32.918 66.3674L32.4496 53.318L26.6733 64.2231L26.8526 51.1604L20.4821 61.5385L21.4992 48.5391L14.3685 58.1202L16.5795 45.361L8.41019 53.5448L12.5243 41.5692L2.93098 46.775L10.2651 37.6308L0 36L10.2651 34.3659L2.93366 25.2183L12.5269 30.4308L8.41286 18.4519L16.5821 26.6357L14.3712 13.8764L21.5019 23.4575L20.4848 10.4582L26.8553 20.8363L26.676 7.77693L32.4523 18.682L32.9207 5.62927L38.2045 16.9178L39.1976 3.90848L44.0558 15.4905L45.4985 2.54785L49.9766 14.3633L51.8182 1.50069L55.943 13.5129L58.1486 0.740343L61.9441 12.9193L64.487 0.243446L67.9667 12.5725L70.8281 0L74 12.4558L77.1719 0L80.0333 12.5725L83.513 0.243446L86.0558 12.9193L89.8514 0.740343L92.0543 13.5129L96.1818 1.50069L98.026 14.3633L102.504 2.54785L103.947 15.4905L108.805 3.91181L109.798 16.9178L115.082 5.62927L115.55 18.682L121.327 7.77693L121.147 20.8396L127.521 10.4582L126.501 23.4575L133.631 13.8798L131.421 26.639L139.59 18.4552L135.476 30.4308L145.069 25.225L137.735 34.3659L148 36Z"
      fill="#f95647"
    />
  </svg>
)

export const TeamShapeOne = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="504"
    height="504"
    viewBox="0 0 504 504"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504 0H0V504H504V0ZM180.747 462.57C143.906 456.632 103.897 440.182 75.6893 414.317C51.9044 392.507 44.5873 370.588 33.6611 340.838C16.6188 294.435 17.5 246 17.5 193C20.1725 155.976 17.1021 113.818 46.4053 87.7668C76.3348 61.1585 119.496 50.5945 157.79 41.2218C158.717 40.9949 159.641 40.7687 160.562 40.543C214.077 27.429 271.84 19.375 327.11 20.5993C472.523 20.5993 483.397 164.5 486 241.5C488.161 305.433 492.608 435.65 448 462.57C403.392 489.491 254.705 474.353 184.251 463.136C183.086 462.947 181.918 462.759 180.747 462.57Z"
      fill="currentColor"
    />
  </svg>
)

export const TeamShapeTwo = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="504"
    height="504"
    viewBox="0 0 504 504"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504 0H0V504H504V0ZM470 356.5C382.053 566.157 -81.2201 483.117 39.9673 162.104C116.19 -8.95151 322.375 23.8189 417.828 92.3748C496.449 148.894 511.084 258.56 470 356.5Z"
      fill="currentColor"
    />
  </svg>
)

export const TeamShapeThree = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="504"
    height="504"
    viewBox="0 0 504 504"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504 0H0V504H504V0ZM466.534 361.212C380.178 593.836 -80.6832 508.35 38.3489 152.194C113.18 -37.6086 321.673 -1.65963 415.055 74.1908C491.971 136.724 506.875 252.543 466.534 361.212Z"
      fill="currentColor"
    />
  </svg>
)

export const TeamShapeFour = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="504"
    height="504"
    viewBox="0 0 504 504"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504 0H0V504H504V0ZM457.5 407.5C349.963 630.539 -150.28 357.547 70.6354 153.881C151.342 79.5349 302.755 -38.5108 410.725 42.8586C499.653 109.94 505.102 308.694 457.5 407.5Z"
      fill="currentColor"
    />
  </svg>
)

export const TeamShapeFive = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="504"
    height="504"
    viewBox="0 0 504 504"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M504 0H0V504H504V0ZM54.3929 293.769C58.2298 278.981 56.3113 264.515 51.9511 250.048C48.3972 238.555 43.2633 227.106 38.1014 215.594C29.3309 196.035 20.48 176.297 19.1625 155.858C16.372 108.923 43.4393 66.8101 89.6573 47.2004C226.044 -10.6643 473.644 58.1304 486.201 223.527C496.317 355.491 429.054 436.662 298.249 466.238C229.881 481.668 157.502 481.025 90.3549 460.933C42.3929 446.628 5.38435 410.302 22.4763 357.741C25.9377 347.108 31.9305 337.335 37.9151 327.577C44.5952 316.684 51.2651 305.807 54.3929 293.769Z"
      fill="currentColor"
    />
  </svg>
)

export const SignupShape = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="130"
    height="69"
    viewBox="0 0 130 69"
    fill="none"
  >
    <path
      d="M93.9364 34.2489C94.5964 50.0992 102.865 63.0332 112.405 63.1377C121.945 63.2421 129.144 50.4776 128.484 34.6273C127.824 18.777 119.555 5.84303 110.015 5.73854C100.475 5.63405 93.2764 18.3986 93.9364 34.2489Z"
      fill="currentColor"
    />
    <path
      d="M67.4188 34.0427C68.2017 52.8438 78.0098 68.1855 89.3259 68.3095C100.642 68.4334 109.181 53.2926 108.398 34.4915C107.615 15.6905 97.807 0.348746 86.4909 0.224806C75.1748 0.100866 66.636 15.2417 67.4188 34.0427Z"
      fill="currentColor"
    />
    <path
      d="M47.9755 34.5331C48.6355 50.3834 56.9043 63.3173 66.4443 63.4218C75.9844 63.5263 83.1831 50.7618 82.5231 34.9114C81.8632 19.0611 73.5944 6.12721 64.0543 6.02273C54.5142 5.91824 47.3155 18.6828 47.9755 34.5331Z"
      fill="currentColor"
    />
    <path
      d="M20.6376 34.3328C21.4204 53.1338 31.2285 68.4756 42.5446 68.5995C53.8607 68.7235 62.3996 53.5827 61.6167 34.7816C60.8339 15.9805 51.0257 0.638785 39.7096 0.514846C28.3936 0.390907 19.8547 15.5317 20.6376 34.3328Z"
      fill="currentColor"
    />
    <path
      d="M1.19426 34.8221C1.85424 50.6724 10.123 63.6063 19.6631 63.7108C29.2031 63.8152 36.4019 51.0507 35.7419 35.2005C35.0819 19.3502 26.8131 6.41628 17.2731 6.31179C7.73299 6.20731 0.534272 18.9718 1.19426 34.8221Z"
      fill="currentColor"
    />
  </svg>
)

export const Caret = ({ className }: SvgProps) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.47961 0.5L6.47961 5.5L11.4796 0.5"
      stroke="white"
      strokeLinecap="round"
    />
  </svg>
)

export const BlackCaret = ({ className }: SvgProps) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cx('block', className)}
  >
    <path
      d="M1.47961 0.5L6.47961 5.5L11.4796 0.5"
      stroke="black"
      strokeLinecap="round"
    />
  </svg>
)

export const BlackMenuIcon = ({ className }: SvgProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.667 21.333C27.4002 21.3332 28 21.9338 28 22.667C27.9998 23.4001 27.4001 23.9998 26.667 24H5.33301C4.59993 23.9998 4.00018 23.4001 4 22.667C4 21.9338 4.59982 21.3332 5.33301 21.333H26.667ZM26.667 14.667C27.4002 14.6672 28 15.2668 28 16C28 16.7332 27.4002 17.3328 26.667 17.333H5.33301C4.59982 17.3328 4 16.7332 4 16C4 15.2668 4.59982 14.6672 5.33301 14.667H26.667ZM26.667 8C27.4001 8.00018 27.9998 8.59993 28 9.33301C28 10.0662 27.4002 10.6668 26.667 10.667H5.33301C4.59982 10.6668 4 10.0662 4 9.33301C4.00018 8.59993 4.59993 8.00018 5.33301 8H26.667Z"
      fill="#282725"
    />
  </svg>
)

export const BlackCloseIcon = ({ className }: SvgProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 8L8 24M8 8L24 24"
      stroke="#282725"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export const SmallCaret = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="13"
    height="8"
    viewBox="0 0 13 8"
    fill="none"
  >
    <path
      d="M1 1L6.5 6.5L12 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export const Twitter = () => (
  <svg width="16" height="13" viewBox="0 0 16 13" fill="none">
    <path
      d="M7.76891 3.4582L7.8036 4.02049L7.22555 3.95164C5.12147 3.68771 3.28329 2.79264 1.72257 1.28938L0.959553 0.543493L0.763018 1.0943C0.346826 2.32215 0.612727 3.61886 1.47979 4.49097C1.94223 4.97293 1.83818 5.04179 1.04048 4.75491C0.763018 4.6631 0.52024 4.59425 0.497118 4.62868C0.416192 4.709 0.693653 5.75325 0.91331 6.16636C1.21389 6.74012 1.82662 7.30241 2.49715 7.63519L3.06363 7.89912L2.3931 7.9106C1.74569 7.9106 1.72257 7.92207 1.79194 8.16305C2.02315 8.90894 2.93646 9.70073 3.95382 10.045L4.6706 10.286L4.04631 10.6532C3.12144 11.181 2.03472 11.4794 0.947992 11.5023C0.427753 11.5138 0 11.5597 0 11.5941C0 11.7089 1.41043 12.3515 2.23125 12.604C4.69372 13.3499 7.61862 13.0286 9.81519 11.7548C11.3759 10.8483 12.9366 9.04664 13.665 7.30241C14.058 6.37291 14.4511 4.67458 14.4511 3.85984C14.4511 3.33198 14.4858 3.26312 15.1332 2.63199C15.5147 2.26478 15.8731 1.86315 15.9425 1.74839C16.0581 1.53036 16.0465 1.53036 15.4569 1.72544C14.4742 2.0697 14.3355 2.0238 14.8211 1.50741C15.1794 1.14021 15.6072 0.474642 15.6072 0.279563C15.6072 0.245137 15.4338 0.302513 15.2372 0.40579C15.0291 0.520543 14.5667 0.692671 14.2199 0.795948L13.5956 0.991027L13.0291 0.612345C12.717 0.40579 12.2777 0.176285 12.0464 0.107434C11.4568 -0.0532193 10.5551 -0.0302688 10.0233 0.153335C8.57817 0.669721 7.66486 2.00085 7.76891 3.4582Z"
      fill="currentColor"
    />
  </svg>
)

export const Facebook = () => (
  <svg width="9" height="18" viewBox="0 0 9 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.65842 4.24137V6.59645H0V9.78821H2.65842V18H5.82178V9.78821H8.46535L8.85148 6.58096H5.88119V4.56675C5.88119 3.63711 6.11881 3.01735 7.36634 3.01735H9V0.150972C8.21147 0.052958 7.41785 0.00638532 6.62376 0.0115258C6.08466 -0.0320457 5.54295 0.0482523 5.03681 0.246762C4.53067 0.445271 4.07242 0.757162 3.69435 1.16046C3.31627 1.56375 3.02757 2.04864 2.84858 2.58095C2.6696 3.11327 2.60468 3.68005 2.65842 4.24137Z"
      fill="currentColor"
    />
  </svg>
)

export const Instagram = () => (
  <svg width="20" height="20" viewBox="0 0 60 60">
    <g
      id="instagram"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Instagram_simple_icon" fill="currentColor" fillRule="nonzero">
        <path
          d="M30,5.41321429 C38.0078571,5.41321429 38.9563095,5.44380952 42.1190476,5.58809524 C45.0430952,5.72154762 46.6309524,6.21 47.6878571,6.62071429 C48.990487,7.10149047 50.1688073,7.86809432 51.1361905,8.86416667 C52.1322628,9.8315498 52.8988667,11.0098702 53.3796429,12.3125 C53.7903571,13.3692857 54.2789286,14.9572619 54.4122619,17.8813095 C54.5565476,21.0438095 54.5871429,21.9922619 54.5871429,30.0003571 C54.5871429,38.0084524 54.5565476,38.9566667 54.4122619,42.1194048 C54.2788095,45.0434524 53.7902381,46.6313095 53.3796429,47.6882143 C52.3707001,50.3037404 50.3033832,52.3710572 47.6878571,53.38 C46.6310714,53.7907143 45.0430952,54.2792857 42.1190476,54.412619 C38.9571429,54.5569048 38.0086905,54.5875 30,54.5875 C21.9913095,54.5875 21.0432143,54.5569048 17.8809524,54.412619 C14.9569048,54.2791667 13.3690476,53.7905952 12.3121429,53.38 C11.0095112,52.8992274 9.83119007,52.1326231 8.86380952,51.1365476 C7.86774032,50.1691619 7.10113696,48.9908423 6.62035714,47.6882143 C6.20964286,46.6314286 5.72107143,45.0434524 5.5877381,42.1194048 C5.44345238,38.9570238 5.41285714,38.0084524 5.41285714,30.0003571 C5.41285714,21.9922619 5.44345238,21.0440476 5.5877381,17.8813095 C5.72119048,14.9572619 6.20964286,13.3694048 6.62035714,12.3125 C7.10118698,11.0098052 7.86787434,9.8314409 8.86404762,8.86404762 C9.83143333,7.86797841 11.0097529,7.10137505 12.312381,6.62059524 C13.3691667,6.20988095 14.9571429,5.72130952 17.8811905,5.58797619 C21.0436905,5.44369048 21.9921429,5.41309524 30.0002381,5.41309524 L30,5.41321429 Z M30.0002381,0.0094047619 C21.8552381,0.0094047619 20.8335714,0.0439285714 17.6352381,0.189880952 C14.4429762,0.335595238 12.2629762,0.8425 10.3553571,1.58392857 C8.35423794,2.33697991 6.54146681,3.51747499 5.04345238,5.04309524 C3.51748832,6.54101574 2.33666361,8.35379395 1.58333333,10.355 C0.8425,12.2627381 0.335595238,14.4427381 0.19047619,17.635 C0.0439285714,20.8333333 0.0094047619,21.855 0.0094047619,30 C0.0094047619,38.145 0.0439285714,39.1666667 0.19047619,42.365 C0.336190476,45.5572619 0.843095238,47.7372619 1.58452381,49.644881 C2.33757857,51.6459984 3.5180732,53.4587688 5.04369048,54.9567857 C6.54170004,56.4824119 8.35447256,57.6629079 10.3555952,58.4159524 C12.2633333,59.157381 14.4433333,59.6642857 17.6354762,59.81 C20.8342857,59.9559524 21.8555952,59.9904762 30.0004762,59.9904762 C38.1453571,59.9904762 39.1671429,59.9559524 42.3654762,59.81 C45.5577381,59.6642857 47.7377381,59.157381 49.6453571,58.4159524 C53.6737789,56.8579129 56.8583891,53.6733027 58.4164286,49.644881 C59.1578571,47.7371429 59.6647619,45.5571429 59.8104762,42.365 C59.9564286,39.1661905 59.9909524,38.144881 59.9909524,30 C59.9909524,21.855119 59.9564286,20.8333333 59.8104762,17.635 C59.6647619,14.4427381 59.1578571,12.2627381 58.4164286,10.355119 C57.6633841,8.35399637 56.4828881,6.54122385 54.9572619,5.04321429 C53.4592169,3.51728988 51.6463138,2.33654447 49.645,1.58333333 C47.7372619,0.8425 45.5572619,0.335595238 42.365,0.19047619 C39.1666667,0.0439285714 38.145,0.0094047619 30,0.0094047619 L30.0002381,0.0094047619 Z"
          id="Shape"
        />
        <path
          d="M30,14.5994048 C21.4944861,14.5994048 14.5994048,21.4944861 14.5994048,30 C14.5994048,38.5055139 21.4944861,45.4005952 30,45.4005952 C38.5055139,45.4005952 45.4005952,38.5055139 45.4005952,30 C45.4005952,21.4944861 38.5055139,14.5994048 30,14.5994048 Z M30,39.9967857 C24.4789432,39.99672 20.0032895,35.5209774 20.0033333,29.9999206 C20.0033772,24.4788638 24.4791019,20.0031924 30.0001587,20.0032143 C35.5212155,20.0032362 39.9969048,24.4789432 39.9969048,30 C39.996839,35.5210916 35.5210916,39.9967857 30,39.9967857 Z"
          id="Shape"
        />
        <circle id="Oval" cx="46.0090476" cy="13.9909524" r="3.59880952" />
      </g>
    </g>
  </svg>
)

export const Mail = () => (
  <svg width="18" height="12" viewBox="0 0 18 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0V12H18V0H0ZM15.1875 1.2L9 4.716L2.8125 1.2H15.1875ZM16.875 10.8H1.125V1.596L9 6.084L16.875 1.596V10.8Z"
      fill="currentColor"
    />
  </svg>
)

export const Arrow = ({ className }: SvgProps) => (
  <svg width="17" height="12" viewBox="0 0 17 12" fill="none">
    <path
      d="M0.469669 5.46967C0.176777 5.76256 0.176777 6.23744 0.469669 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.469669 5.46967ZM17 5.25L1 5.25L1 6.75L17 6.75L17 5.25Z"
      fill="currentColor"
    />
  </svg>
)

export const ShareArrow = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M16.0637 4.99977C16.0637 4.58555 15.7279 4.24977 15.3137 4.24977L8.56371 4.24977C8.14949 4.24977 7.81371 4.58555 7.81371 4.99977C7.81371 5.41398 8.14949 5.74977 8.56371 5.74977H14.5637V11.7498C14.5637 12.164 14.8995 12.4998 15.3137 12.4998C15.7279 12.4998 16.0637 12.164 16.0637 11.7498L16.0637 4.99977ZM4.53033 16.8438L15.844 5.5301L14.7834 4.46944L3.46967 15.7831L4.53033 16.8438Z"
      fill="currentColor"
    />
  </svg>
)

export const AnnotationArrow = ({ className }: SvgProps) => (
  <svg width="42" height="16" viewBox="0 0 42 16" fill="none">
    <path
      d="M40.7071 8.70711C41.0976 8.31658 41.0976 7.68342 40.7071 7.29289L34.3431 0.928932C33.9526 0.538408 33.3195 0.538408 32.9289 0.928932C32.5384 1.31946 32.5384 1.95262 32.9289 2.34315L38.5858 8L32.9289 13.6569C32.5384 14.0474 32.5384 14.6805 32.9289 15.0711C33.3195 15.4616 33.9526 15.4616 34.3431 15.0711L40.7071 8.70711ZM0 9L40 9V7L0 7L0 9Z"
      fill="currentColor"
    />
  </svg>
)

export const AnnotationClose = ({ className }: SvgProps) => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
    <line
      y1="-1"
      x2="19.9"
      y2="-1"
      transform="matrix(0.710658 0.703537 -0.710658 0.703537 1 2.08691)"
      stroke="currentColor"
      stroke-width="2"
    />
    <line
      y1="-1"
      x2="19.9"
      y2="-1"
      transform="matrix(0.710658 0.703537 -0.710658 0.703537 1 2.08691)"
      stroke="currentColor"
      stroke-width="2"
    />
    <line
      y1="-1"
      x2="19.9"
      y2="-1"
      transform="matrix(0.710658 -0.703537 0.710658 0.703537 2 16.0879)"
      stroke="currentColor"
      stroke-width="2"
    />
    <line
      y1="-1"
      x2="19.9"
      y2="-1"
      transform="matrix(0.710658 -0.703537 0.710658 0.703537 2 16.0879)"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
)

export const EditorialArrow = ({ className }: SvgProps) => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path
      d="M15.5303 6.53033C15.8232 6.23744 15.8232 5.76256 15.5303 5.46967L10.7574 0.696699C10.4645 0.403806 9.98959 0.403806 9.6967 0.696699C9.40381 0.989593 9.40381 1.46447 9.6967 1.75736L13.9393 6L9.6967 10.2426C9.40381 10.5355 9.40381 11.0104 9.6967 11.3033C9.98959 11.5962 10.4645 11.5962 10.7574 11.3033L15.5303 6.53033ZM0 6.75H15V5.25H0V6.75Z"
      fill="currentColor"
    />
  </svg>
)

export const SideWave = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="38"
    height="408"
    viewBox="0 0 38 408"
    fill="none"
  >
    <path
      d="M6.13073 0.000121695L36.883 -9.15616e-05C36.883 161.888 37.6251 260.044 37.625 407.5L5.43432 407.5C5.43432 407.5 46.3498 370.01 21.7573 283.198C-2.83533 196.385 -8.92437 186.936 15.7355 106.619C40.3954 26.3029 6.13073 0.000121695 6.13073 0.000121695Z"
      fill="currentColor"
    />
  </svg>
)

export const SmallWave = ({ className }: SvgProps) => (
  <svg className={cx('block', className)} viewBox="0 0 324 15" fill="none">
    <path
      d="M324 6.9403V15L162 15L0 15L0 0C0 0 49.4666 6.9403 92.4811 6.9403C135.496 6.9403 188.884 0 231.898 0C274.913 0 324 6.9403 324 6.9403Z"
      fill="currentColor"
    />
  </svg>
)

export const SmallArrow = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="44"
    height="37"
    viewBox="0 0 44 37"
    fill="none"
  >
    <path
      d="M29.8755 19.4419C30.1196 19.1979 30.1196 18.8021 29.8755 18.5581L25.898 14.5806C25.6539 14.3365 25.2582 14.3365 25.0141 14.5806C24.7701 14.8247 24.7701 15.2204 25.0141 15.4645L28.5497 19L25.0141 22.5355C24.7701 22.7796 24.7701 23.1753 25.0141 23.4194C25.2582 23.6635 25.6539 23.6635 25.898 23.4194L29.8755 19.4419ZM10.5977 19.625L29.4335 19.625L29.4335 18.375L10.5977 18.375L10.5977 19.625Z"
      fill="currentColor"
    />
  </svg>
)

export const UpArrow = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M6 16L6 16.75L5.25 16.75L5.25 16L6 16ZM5.46967 0.46967C5.76256 0.176777 6.23744 0.176777 6.53033 0.46967L11.3033 5.24264C11.5962 5.53553 11.5962 6.01041 11.3033 6.3033C11.0104 6.59619 10.5355 6.59619 10.2426 6.3033L6 2.06066L1.75736 6.3033C1.46447 6.59619 0.989592 6.59619 0.696699 6.3033C0.403806 6.01041 0.403806 5.53553 0.696699 5.24264L5.46967 0.46967ZM16 16.75L6 16.75L6 15.25L16 15.25L16 16.75ZM5.25 16L5.25 1L6.75 1L6.75 16L5.25 16Z"
      fill="currentColor"
    />
  </svg>
)

export const LeftThread = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="213"
    height="48"
    viewBox="0 0 213 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M153.598 47.0012C140.773 47.0012 134.365 37.5097 128.162 28.341C121.951 19.1453 116.081 10.4695 104.214 10.4695C92.3477 10.4695 86.4772 19.1543 80.2661 28.341C74.0639 37.5187 67.6557 47.0012 54.8301 47.0012C42.0136 47.0012 35.5963 37.5097 29.3942 28.341C23.1831 19.1453 17.3125 10.4695 5.446 10.4695C-6.42053 10.4695 -12.2911 19.1543 -18.5022 28.341C-24.7043 37.5187 -31.1126 47.0012 -43.9292 47.0012C-56.7457 47.0012 -63.163 37.5097 -69.3562 28.341C-75.5673 19.1453 -81.4378 10.4695 -93.3043 10.4695C-105.171 10.4695 -111.041 19.1543 -117.253 28.341C-123.455 37.5187 -129.863 47.0012 -142.688 47.0012C-155.505 47.0012 -161.922 37.5097 -168.115 28.341C-174.318 19.1453 -180.188 10.4605 -192.055 10.4605V8.66797C-179.238 8.66797 -172.821 18.1594 -166.628 27.3282C-160.417 36.5238 -154.546 45.1997 -142.68 45.1997C-130.813 45.1997 -124.942 36.5149 -118.731 27.3282C-112.529 18.1504 -106.121 8.66797 -93.2954 8.66797C-80.4788 8.66797 -74.0616 18.1594 -67.8684 27.3282C-61.6573 36.5238 -55.7867 45.1997 -43.9202 45.1997C-32.0537 45.1997 -26.1832 36.5149 -19.972 27.3282C-13.7699 18.1504 -7.36162 8.66797 5.45496 8.66797C18.2715 8.66797 24.6888 18.1594 30.8909 27.3282C37.102 36.5238 42.9726 45.1997 54.8391 45.1997C66.7056 45.1997 72.5762 36.5149 78.7873 27.3282C84.9894 18.1504 91.3977 8.66797 104.223 8.66797C117.049 8.66797 123.457 18.1594 129.659 27.3282C135.87 36.5238 141.741 45.1997 153.607 45.1997C165.474 45.1997 171.344 36.5149 177.556 27.3282C183.758 18.1504 190.166 8.66797 202.991 8.66797V10.4605C191.125 10.4605 185.254 19.1453 179.043 28.332C172.832 37.5097 166.424 47.0012 153.598 47.0012Z"
      fill="#FFF8EF"
      stroke="white"
    />
    <path
      d="M5.46157 19.1263C10.7406 19.1263 15.0247 14.8421 15.0247 9.56314C15.0247 4.28414 10.7406 0 5.46157 0C0.182577 0 -4.10156 4.28414 -4.10156 9.56314C-4.10156 14.8421 0.182577 19.1263 5.46157 19.1263Z"
      fill="#EF308D"
    />
    <path
      d="M81.1022 37.3919C86.3812 37.3919 90.6653 33.1078 90.6653 27.8288C90.6653 22.5498 86.3812 18.2656 81.1022 18.2656C75.8232 18.2656 71.5391 22.5498 71.5391 27.8288C71.5391 33.1167 75.8232 37.3919 81.1022 37.3919Z"
      fill="#EF308D"
    />
    <path
      d="M202.985 19.1263C208.264 19.1263 212.548 14.8421 212.548 9.56314C212.548 4.28414 208.264 0 202.985 0C197.706 0 193.422 4.28414 193.422 9.56314C193.422 14.8421 197.706 19.1263 202.985 19.1263Z"
      fill="#EF308D"
    />
  </svg>
)

export const RightThread = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="234"
    height="48"
    viewBox="0 0 234 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M353.166 47.0012C340.597 47.0012 334.317 37.5097 328.239 28.341C322.152 19.1453 316.399 10.4695 304.769 10.4695C293.14 10.4695 287.387 19.1543 281.3 28.341C275.222 37.5187 268.942 47.0012 256.373 47.0012C243.813 47.0012 237.524 37.5097 231.446 28.341C225.359 19.1453 219.606 10.4695 207.976 10.4695C196.347 10.4695 190.594 19.1543 184.507 28.341C178.429 37.5187 172.149 47.0012 159.589 47.0012C147.029 47.0012 140.74 37.5097 134.67 28.341C128.583 19.1453 122.83 10.4695 111.201 10.4695C99.5719 10.4695 93.8188 19.1543 87.7319 28.341C81.6538 37.5187 75.3737 47.0012 62.8047 47.0012C50.2444 47.0012 43.9555 37.5097 37.8862 28.341C31.8081 19.1453 26.055 10.4605 14.4258 10.4605V8.66797C26.986 8.66797 33.2749 18.1594 39.3442 27.3282C45.4311 36.5238 51.1842 45.1997 62.8134 45.1997C74.4426 45.1997 80.1958 36.5149 86.2827 27.3282C92.3608 18.1504 98.6409 8.66797 111.21 8.66797C123.77 8.66797 130.059 18.1594 136.128 27.3282C142.215 36.5238 147.968 45.1997 159.598 45.1997C171.227 45.1997 176.98 36.5149 183.067 27.3282C189.145 18.1504 195.425 8.66797 207.985 8.66797C220.545 8.66797 226.834 18.1594 232.912 27.3282C238.999 36.5238 244.752 45.1997 256.382 45.1997C268.011 45.1997 273.764 36.5149 279.851 27.3282C285.929 18.1504 292.209 8.66797 304.778 8.66797C317.347 8.66797 323.627 18.1594 329.705 27.3282C335.792 36.5238 341.545 45.1997 353.175 45.1997C364.804 45.1997 370.557 36.5149 376.644 27.3282C382.722 18.1504 389.002 8.66797 401.571 8.66797V10.4605C389.942 10.4605 384.189 19.1453 378.102 28.332C372.015 37.5097 365.735 47.0012 353.166 47.0012Z"
      fill="#FFF8EF"
      stroke="white"
    />
    <path
      d="M78.6727 46.9544C83.8461 46.9544 88.0445 42.6703 88.0445 37.3913C88.0445 32.1123 83.8461 27.8281 78.6727 27.8281C73.4992 27.8281 69.3008 32.1123 69.3008 37.3913C69.3008 42.6792 73.4992 46.9544 78.6727 46.9544Z"
      fill="#EF308D"
    />
    <path
      d="M207.993 19.1263C213.166 19.1263 217.365 14.8421 217.365 9.56314C217.365 4.28414 213.166 0 207.993 0C202.82 0 198.621 4.28414 198.621 9.56314C198.621 14.8421 202.82 19.1263 207.993 19.1263Z"
      fill="#EF308D"
    />
    <path
      d="M10.1297 19.1263C15.3031 19.1263 19.5016 14.8421 19.5016 9.56314C19.5016 4.28414 15.3031 0 10.1297 0C4.95627 0 0.757812 4.28414 0.757812 9.56314C0.757812 14.8421 4.95627 19.1263 10.1297 19.1263Z"
      fill="#EF308D"
    />
  </svg>
)

export const Discorectangle = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="151"
    height="186"
    viewBox="0 0 151 186"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78.7011 62.68C61.9411 62.68 48.3611 49.09 48.3611 32.34C48.3611 15.58 61.9511 1.99999 78.7011 1.99999L277.871 2"
      stroke="white"
      stroke-width="3"
      stroke-miterlimit="10"
      stroke-linejoin="bevel"
    />
    <path
      d="M78.7 62.6797L236.66 62.6797C253.42 62.6797 267 76.2697 267 93.0197C267 109.78 253.41 123.36 236.66 123.36"
      stroke="white"
      stroke-width="3"
      stroke-miterlimit="10"
      stroke-linejoin="bevel"
    />
    <path
      d="M298.48 184.06L41.6105 184.06C24.8505 184.06 11.2705 170.47 11.2705 153.72C11.2705 136.96 24.8605 123.38 41.6105 123.38L236.66 123.38"
      stroke="white"
      stroke-width="3"
      stroke-miterlimit="10"
      stroke-linejoin="bevel"
    />
    <path
      d="M36.9606 32.3302C36.9606 38.8693 42.2616 44.1702 48.8006 44.1702C55.3397 44.1702 60.6406 38.8693 60.6406 32.3302C60.6406 25.7912 55.3397 20.4902 48.8006 20.4902C42.2616 20.4902 36.9606 25.7912 36.9606 32.3302Z"
      fill="#EF308D"
    />
    <path
      d="M36.9606 32.3302C36.9606 38.8693 42.2616 44.1702 48.8006 44.1702C55.3397 44.1702 60.6406 38.8693 60.6406 32.3302C60.6406 25.7912 55.3397 20.4902 48.8006 20.4902C42.2616 20.4902 36.9606 25.7912 36.9606 32.3302Z"
      stroke="white"
    />
    <path
      d="M0.00189158 155.95C0.0018913 162.417 5.24463 167.66 11.7119 167.66C18.1791 167.66 23.4219 162.417 23.4219 155.95C23.4219 149.483 18.1791 144.24 11.7119 144.24C5.24463 144.24 0.00189186 149.483 0.00189158 155.95Z"
      fill="#EF308D"
    />
    <path
      d="M0.00189158 155.95C0.0018913 162.417 5.24463 167.66 11.7119 167.66C18.1791 167.66 23.4219 162.417 23.4219 155.95C23.4219 149.483 18.1791 144.24 11.7119 144.24C5.24463 144.24 0.00189186 149.483 0.00189158 155.95Z"
      stroke="white"
    />
  </svg>
)

export const Waves = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="1279"
    height="12"
    viewBox="0 0 1279 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.8712 10.3077C48.9429 10.3077 46.98 8.00308 45.0804 5.7768C43.1779 3.544 41.3798 1.43742 37.7452 1.43742C34.1106 1.43742 32.3125 3.54618 30.41 5.7768C28.5104 8.00525 26.5475 10.3077 22.6192 10.3077C18.6935 10.3077 16.728 8.00308 14.8283 5.7768C12.9259 3.544 11.1278 1.43742 7.49314 1.43742C3.8585 1.43742 2.06039 3.54618 0.157974 5.7768C-1.7417 8.00525 -3.70451 10.3077 -7.63014 10.3077C-11.5558 10.3077 -13.5213 8.00308 -15.4183 5.7768C-17.3207 3.544 -19.1188 1.43742 -22.7534 1.43742C-26.3881 1.43742 -28.1862 3.54618 -30.0886 5.7768C-31.9883 8.00525 -33.9511 10.3077 -37.8795 10.3077C-41.8051 10.3077 -43.7707 8.00308 -45.6676 5.7768C-47.5673 3.544 -49.3654 1.43524 -53 1.43524V1C-49.0744 1 -47.1088 3.30462 -45.2119 5.53089C-43.3095 7.76369 -41.5114 9.87027 -37.8767 9.87027C-34.2421 9.87027 -32.444 7.76152 -30.5416 5.53089C-28.6419 3.30244 -26.6791 1 -22.7507 1C-18.8251 1 -16.8595 3.30462 -14.9626 5.53089C-13.0601 7.76369 -11.262 9.87027 -7.6274 9.87027C-3.99276 9.87027 -2.19466 7.76152 -0.292236 5.53089C1.60744 3.30244 3.57026 1 7.49588 1C11.4215 1 13.3871 3.30462 15.2868 5.53089C17.1892 7.76369 18.9873 9.87027 22.6219 9.87027C26.2565 9.87027 28.0547 7.76152 29.9571 5.53089C31.8568 3.30244 33.8196 1 37.748 1C41.6763 1 43.6391 3.30462 45.5388 5.53089C47.4412 7.76369 49.2393 9.87027 52.874 9.87027C56.5086 9.87027 58.3067 7.76152 60.2091 5.53089C62.1088 3.30244 64.0716 1 68 1V1.43524C64.3654 1.43524 62.5673 3.544 60.6648 5.77463C58.7624 8.00308 56.7996 10.3077 52.8712 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M173.871 10.3077C169.943 10.3077 167.98 8.00308 166.08 5.7768C164.178 3.544 162.38 1.43742 158.745 1.43742C155.111 1.43742 153.312 3.54618 151.41 5.7768C149.51 8.00525 147.548 10.3077 143.619 10.3077C139.694 10.3077 137.728 8.00308 135.828 5.7768C133.926 3.544 132.128 1.43742 128.493 1.43742C124.859 1.43742 123.06 3.54618 121.158 5.7768C119.258 8.00525 117.295 10.3077 113.37 10.3077C109.444 10.3077 107.479 8.00308 105.582 5.7768C103.679 3.544 101.881 1.43742 98.2466 1.43742C94.6119 1.43742 92.8138 3.54618 90.9114 5.7768C89.0117 8.00525 87.0489 10.3077 83.1205 10.3077C79.1949 10.3077 77.2293 8.00308 75.3324 5.7768C73.4327 3.544 71.6346 1.43524 68 1.43524V1C71.9256 1 73.8912 3.30462 75.7881 5.53089C77.6905 7.76369 79.4886 9.87027 83.1233 9.87027C86.7579 9.87027 88.556 7.76152 90.4584 5.53089C92.3581 3.30244 94.3209 1 98.2493 1C102.175 1 104.141 3.30462 106.037 5.53089C107.94 7.76369 109.738 9.87027 113.373 9.87027C117.007 9.87027 118.805 7.76152 120.708 5.53089C122.607 3.30244 124.57 1 128.496 1C132.422 1 134.387 3.30462 136.287 5.53089C138.189 7.76369 139.987 9.87027 143.622 9.87027C147.257 9.87027 149.055 7.76152 150.957 5.53089C152.857 3.30244 154.82 1 158.748 1C162.676 1 164.639 3.30462 166.539 5.53089C168.441 7.76369 170.239 9.87027 173.874 9.87027C177.509 9.87027 179.307 7.76152 181.209 5.53089C183.109 3.30244 185.072 1 189 1V1.43524C185.365 1.43524 183.567 3.544 181.665 5.77463C179.762 8.00308 177.8 10.3077 173.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M294.871 10.3077C290.943 10.3077 288.98 8.00308 287.08 5.7768C285.178 3.544 283.38 1.43742 279.745 1.43742C276.111 1.43742 274.312 3.54618 272.41 5.7768C270.51 8.00525 268.548 10.3077 264.619 10.3077C260.694 10.3077 258.728 8.00308 256.828 5.7768C254.926 3.544 253.128 1.43742 249.493 1.43742C245.859 1.43742 244.06 3.54618 242.158 5.7768C240.258 8.00525 238.295 10.3077 234.37 10.3077C230.444 10.3077 228.479 8.00308 226.582 5.7768C224.679 3.544 222.881 1.43742 219.247 1.43742C215.612 1.43742 213.814 3.54618 211.911 5.7768C210.012 8.00525 208.049 10.3077 204.121 10.3077C200.195 10.3077 198.229 8.00308 196.332 5.7768C194.433 3.544 192.635 1.43524 189 1.43524V1C192.926 1 194.891 3.30462 196.788 5.53089C198.691 7.76369 200.489 9.87027 204.123 9.87027C207.758 9.87027 209.556 7.76152 211.458 5.53089C213.358 3.30244 215.321 1 219.249 1C223.175 1 225.141 3.30462 227.037 5.53089C228.94 7.76369 230.738 9.87027 234.373 9.87027C238.007 9.87027 239.805 7.76152 241.708 5.53089C243.607 3.30244 245.57 1 249.496 1C253.422 1 255.387 3.30462 257.287 5.53089C259.189 7.76369 260.987 9.87027 264.622 9.87027C268.257 9.87027 270.055 7.76152 271.957 5.53089C273.857 3.30244 275.82 1 279.748 1C283.676 1 285.639 3.30462 287.539 5.53089C289.441 7.76369 291.239 9.87027 294.874 9.87027C298.509 9.87027 300.307 7.76152 302.209 5.53089C304.109 3.30244 306.072 1 310 1V1.43524C306.365 1.43524 304.567 3.544 302.665 5.77463C300.762 8.00308 298.8 10.3077 294.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M415.871 10.3077C411.943 10.3077 409.98 8.00308 408.08 5.7768C406.178 3.544 404.38 1.43742 400.745 1.43742C397.111 1.43742 395.312 3.54618 393.41 5.7768C391.51 8.00525 389.548 10.3077 385.619 10.3077C381.694 10.3077 379.728 8.00308 377.828 5.7768C375.926 3.544 374.128 1.43742 370.493 1.43742C366.859 1.43742 365.06 3.54618 363.158 5.7768C361.258 8.00525 359.295 10.3077 355.37 10.3077C351.444 10.3077 349.479 8.00308 347.582 5.7768C345.679 3.544 343.881 1.43742 340.247 1.43742C336.612 1.43742 334.814 3.54618 332.911 5.7768C331.012 8.00525 329.049 10.3077 325.121 10.3077C321.195 10.3077 319.229 8.00308 317.332 5.7768C315.433 3.544 313.635 1.43524 310 1.43524V1C313.926 1 315.891 3.30462 317.788 5.53089C319.691 7.76369 321.489 9.87027 325.123 9.87027C328.758 9.87027 330.556 7.76152 332.458 5.53089C334.358 3.30244 336.321 1 340.249 1C344.175 1 346.141 3.30462 348.037 5.53089C349.94 7.76369 351.738 9.87027 355.373 9.87027C359.007 9.87027 360.805 7.76152 362.708 5.53089C364.607 3.30244 366.57 1 370.496 1C374.422 1 376.387 3.30462 378.287 5.53089C380.189 7.76369 381.987 9.87027 385.622 9.87027C389.257 9.87027 391.055 7.76152 392.957 5.53089C394.857 3.30244 396.82 1 400.748 1C404.676 1 406.639 3.30462 408.539 5.53089C410.441 7.76369 412.239 9.87027 415.874 9.87027C419.509 9.87027 421.307 7.76152 423.209 5.53089C425.109 3.30244 427.072 1 431 1V1.43524C427.365 1.43524 425.567 3.544 423.665 5.77463C421.762 8.00308 419.8 10.3077 415.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M536.871 10.3077C532.943 10.3077 530.98 8.00308 529.08 5.7768C527.178 3.544 525.38 1.43742 521.745 1.43742C518.111 1.43742 516.312 3.54618 514.41 5.7768C512.51 8.00525 510.548 10.3077 506.619 10.3077C502.694 10.3077 500.728 8.00308 498.828 5.7768C496.926 3.544 495.128 1.43742 491.493 1.43742C487.859 1.43742 486.06 3.54618 484.158 5.7768C482.258 8.00525 480.295 10.3077 476.37 10.3077C472.444 10.3077 470.479 8.00308 468.582 5.7768C466.679 3.544 464.881 1.43742 461.247 1.43742C457.612 1.43742 455.814 3.54618 453.911 5.7768C452.012 8.00525 450.049 10.3077 446.121 10.3077C442.195 10.3077 440.229 8.00308 438.332 5.7768C436.433 3.544 434.635 1.43524 431 1.43524V1C434.926 1 436.891 3.30462 438.788 5.53089C440.691 7.76369 442.489 9.87027 446.123 9.87027C449.758 9.87027 451.556 7.76152 453.458 5.53089C455.358 3.30244 457.321 1 461.249 1C465.175 1 467.141 3.30462 469.037 5.53089C470.94 7.76369 472.738 9.87027 476.373 9.87027C480.007 9.87027 481.805 7.76152 483.708 5.53089C485.607 3.30244 487.57 1 491.496 1C495.422 1 497.387 3.30462 499.287 5.53089C501.189 7.76369 502.987 9.87027 506.622 9.87027C510.257 9.87027 512.055 7.76152 513.957 5.53089C515.857 3.30244 517.82 1 521.748 1C525.676 1 527.639 3.30462 529.539 5.53089C531.441 7.76369 533.239 9.87027 536.874 9.87027C540.509 9.87027 542.307 7.76152 544.209 5.53089C546.109 3.30244 548.072 1 552 1V1.43524C548.365 1.43524 546.567 3.544 544.665 5.77463C542.762 8.00308 540.8 10.3077 536.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M657.871 10.3077C653.943 10.3077 651.98 8.00308 650.08 5.7768C648.178 3.544 646.38 1.43742 642.745 1.43742C639.111 1.43742 637.312 3.54618 635.41 5.7768C633.51 8.00525 631.548 10.3077 627.619 10.3077C623.694 10.3077 621.728 8.00308 619.828 5.7768C617.926 3.544 616.128 1.43742 612.493 1.43742C608.859 1.43742 607.06 3.54618 605.158 5.7768C603.258 8.00525 601.295 10.3077 597.37 10.3077C593.444 10.3077 591.479 8.00308 589.582 5.7768C587.679 3.544 585.881 1.43742 582.247 1.43742C578.612 1.43742 576.814 3.54618 574.911 5.7768C573.012 8.00525 571.049 10.3077 567.121 10.3077C563.195 10.3077 561.229 8.00308 559.332 5.7768C557.433 3.544 555.635 1.43524 552 1.43524V1C555.926 1 557.891 3.30462 559.788 5.53089C561.691 7.76369 563.489 9.87027 567.123 9.87027C570.758 9.87027 572.556 7.76152 574.458 5.53089C576.358 3.30244 578.321 1 582.249 1C586.175 1 588.141 3.30462 590.037 5.53089C591.94 7.76369 593.738 9.87027 597.373 9.87027C601.007 9.87027 602.805 7.76152 604.708 5.53089C606.607 3.30244 608.57 1 612.496 1C616.422 1 618.387 3.30462 620.287 5.53089C622.189 7.76369 623.987 9.87027 627.622 9.87027C631.257 9.87027 633.055 7.76152 634.957 5.53089C636.857 3.30244 638.82 1 642.748 1C646.676 1 648.639 3.30462 650.539 5.53089C652.441 7.76369 654.239 9.87027 657.874 9.87027C661.509 9.87027 663.307 7.76152 665.209 5.53089C667.109 3.30244 669.072 1 673 1V1.43524C669.365 1.43524 667.567 3.544 665.665 5.77463C663.762 8.00308 661.8 10.3077 657.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M778.871 10.3077C774.943 10.3077 772.98 8.00308 771.08 5.7768C769.178 3.544 767.38 1.43742 763.745 1.43742C760.111 1.43742 758.312 3.54618 756.41 5.7768C754.51 8.00525 752.548 10.3077 748.619 10.3077C744.694 10.3077 742.728 8.00308 740.828 5.7768C738.926 3.544 737.128 1.43742 733.493 1.43742C729.859 1.43742 728.06 3.54618 726.158 5.7768C724.258 8.00525 722.295 10.3077 718.37 10.3077C714.444 10.3077 712.479 8.00308 710.582 5.7768C708.679 3.544 706.881 1.43742 703.247 1.43742C699.612 1.43742 697.814 3.54618 695.911 5.7768C694.012 8.00525 692.049 10.3077 688.121 10.3077C684.195 10.3077 682.229 8.00308 680.332 5.7768C678.433 3.544 676.635 1.43524 673 1.43524V1C676.926 1 678.891 3.30462 680.788 5.53089C682.691 7.76369 684.489 9.87027 688.123 9.87027C691.758 9.87027 693.556 7.76152 695.458 5.53089C697.358 3.30244 699.321 1 703.249 1C707.175 1 709.141 3.30462 711.037 5.53089C712.94 7.76369 714.738 9.87027 718.373 9.87027C722.007 9.87027 723.805 7.76152 725.708 5.53089C727.607 3.30244 729.57 1 733.496 1C737.422 1 739.387 3.30462 741.287 5.53089C743.189 7.76369 744.987 9.87027 748.622 9.87027C752.257 9.87027 754.055 7.76152 755.957 5.53089C757.857 3.30244 759.82 1 763.748 1C767.676 1 769.639 3.30462 771.539 5.53089C773.441 7.76369 775.239 9.87027 778.874 9.87027C782.509 9.87027 784.307 7.76152 786.209 5.53089C788.109 3.30244 790.072 1 794 1V1.43524C790.365 1.43524 788.567 3.544 786.665 5.77463C784.762 8.00308 782.8 10.3077 778.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M899.871 10.3077C895.943 10.3077 893.98 8.00308 892.08 5.7768C890.178 3.544 888.38 1.43742 884.745 1.43742C881.111 1.43742 879.312 3.54618 877.41 5.7768C875.51 8.00525 873.548 10.3077 869.619 10.3077C865.694 10.3077 863.728 8.00308 861.828 5.7768C859.926 3.544 858.128 1.43742 854.493 1.43742C850.859 1.43742 849.06 3.54618 847.158 5.7768C845.258 8.00525 843.295 10.3077 839.37 10.3077C835.444 10.3077 833.479 8.00308 831.582 5.7768C829.679 3.544 827.881 1.43742 824.247 1.43742C820.612 1.43742 818.814 3.54618 816.911 5.7768C815.012 8.00525 813.049 10.3077 809.121 10.3077C805.195 10.3077 803.229 8.00308 801.332 5.7768C799.433 3.544 797.635 1.43524 794 1.43524V1C797.926 1 799.891 3.30462 801.788 5.53089C803.691 7.76369 805.489 9.87027 809.123 9.87027C812.758 9.87027 814.556 7.76152 816.458 5.53089C818.358 3.30244 820.321 1 824.249 1C828.175 1 830.141 3.30462 832.037 5.53089C833.94 7.76369 835.738 9.87027 839.373 9.87027C843.007 9.87027 844.805 7.76152 846.708 5.53089C848.607 3.30244 850.57 1 854.496 1C858.422 1 860.387 3.30462 862.287 5.53089C864.189 7.76369 865.987 9.87027 869.622 9.87027C873.257 9.87027 875.055 7.76152 876.957 5.53089C878.857 3.30244 880.82 1 884.748 1C888.676 1 890.639 3.30462 892.539 5.53089C894.441 7.76369 896.239 9.87027 899.874 9.87027C903.509 9.87027 905.307 7.76152 907.209 5.53089C909.109 3.30244 911.072 1 915 1V1.43524C911.365 1.43524 909.567 3.544 907.665 5.77463C905.762 8.00308 903.8 10.3077 899.871 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M1020.87 10.3077C1016.94 10.3077 1014.98 8.00308 1013.08 5.7768C1011.18 3.544 1009.38 1.43742 1005.75 1.43742C1002.11 1.43742 1000.31 3.54618 998.41 5.7768C996.51 8.00525 994.548 10.3077 990.619 10.3077C986.694 10.3077 984.728 8.00308 982.828 5.7768C980.926 3.544 979.128 1.43742 975.493 1.43742C971.859 1.43742 970.06 3.54618 968.158 5.7768C966.258 8.00525 964.295 10.3077 960.37 10.3077C956.444 10.3077 954.479 8.00308 952.582 5.7768C950.679 3.544 948.881 1.43742 945.247 1.43742C941.612 1.43742 939.814 3.54618 937.911 5.7768C936.012 8.00525 934.049 10.3077 930.121 10.3077C926.195 10.3077 924.229 8.00308 922.332 5.7768C920.433 3.544 918.635 1.43524 915 1.43524V1C918.926 1 920.891 3.30462 922.788 5.53089C924.691 7.76369 926.489 9.87027 930.123 9.87027C933.758 9.87027 935.556 7.76152 937.458 5.53089C939.358 3.30244 941.321 1 945.249 1C949.175 1 951.141 3.30462 953.037 5.53089C954.94 7.76369 956.738 9.87027 960.373 9.87027C964.007 9.87027 965.805 7.76152 967.708 5.53089C969.607 3.30244 971.57 1 975.496 1C979.422 1 981.387 3.30462 983.287 5.53089C985.189 7.76369 986.987 9.87027 990.622 9.87027C994.257 9.87027 996.055 7.76152 997.957 5.53089C999.857 3.30244 1001.82 1 1005.75 1C1009.68 1 1011.64 3.30462 1013.54 5.53089C1015.44 7.76369 1017.24 9.87027 1020.87 9.87027C1024.51 9.87027 1026.31 7.76152 1028.21 5.53089C1030.11 3.30244 1032.07 1 1036 1V1.43524C1032.37 1.43524 1030.57 3.544 1028.66 5.77463C1026.76 8.00308 1024.8 10.3077 1020.87 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M1141.87 10.3077C1137.94 10.3077 1135.98 8.00308 1134.08 5.7768C1132.18 3.544 1130.38 1.43742 1126.75 1.43742C1123.11 1.43742 1121.31 3.54618 1119.41 5.7768C1117.51 8.00525 1115.55 10.3077 1111.62 10.3077C1107.69 10.3077 1105.73 8.00308 1103.83 5.7768C1101.93 3.544 1100.13 1.43742 1096.49 1.43742C1092.86 1.43742 1091.06 3.54618 1089.16 5.7768C1087.26 8.00525 1085.3 10.3077 1081.37 10.3077C1077.44 10.3077 1075.48 8.00308 1073.58 5.7768C1071.68 3.544 1069.88 1.43742 1066.25 1.43742C1062.61 1.43742 1060.81 3.54618 1058.91 5.7768C1057.01 8.00525 1055.05 10.3077 1051.12 10.3077C1047.19 10.3077 1045.23 8.00308 1043.33 5.7768C1041.43 3.544 1039.63 1.43524 1036 1.43524V1C1039.93 1 1041.89 3.30462 1043.79 5.53089C1045.69 7.76369 1047.49 9.87027 1051.12 9.87027C1054.76 9.87027 1056.56 7.76152 1058.46 5.53089C1060.36 3.30244 1062.32 1 1066.25 1C1070.17 1 1072.14 3.30462 1074.04 5.53089C1075.94 7.76369 1077.74 9.87027 1081.37 9.87027C1085.01 9.87027 1086.81 7.76152 1088.71 5.53089C1090.61 3.30244 1092.57 1 1096.5 1C1100.42 1 1102.39 3.30462 1104.29 5.53089C1106.19 7.76369 1107.99 9.87027 1111.62 9.87027C1115.26 9.87027 1117.05 7.76152 1118.96 5.53089C1120.86 3.30244 1122.82 1 1126.75 1C1130.68 1 1132.64 3.30462 1134.54 5.53089C1136.44 7.76369 1138.24 9.87027 1141.87 9.87027C1145.51 9.87027 1147.31 7.76152 1149.21 5.53089C1151.11 3.30244 1153.07 1 1157 1V1.43524C1153.37 1.43524 1151.57 3.544 1149.66 5.77463C1147.76 8.00308 1145.8 10.3077 1141.87 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
    <path
      d="M1262.87 10.3077C1258.94 10.3077 1256.98 8.00308 1255.08 5.7768C1253.18 3.544 1251.38 1.43742 1247.75 1.43742C1244.11 1.43742 1242.31 3.54618 1240.41 5.7768C1238.51 8.00525 1236.55 10.3077 1232.62 10.3077C1228.69 10.3077 1226.73 8.00308 1224.83 5.7768C1222.93 3.544 1221.13 1.43742 1217.49 1.43742C1213.86 1.43742 1212.06 3.54618 1210.16 5.7768C1208.26 8.00525 1206.3 10.3077 1202.37 10.3077C1198.44 10.3077 1196.48 8.00308 1194.58 5.7768C1192.68 3.544 1190.88 1.43742 1187.25 1.43742C1183.61 1.43742 1181.81 3.54618 1179.91 5.7768C1178.01 8.00525 1176.05 10.3077 1172.12 10.3077C1168.19 10.3077 1166.23 8.00308 1164.33 5.7768C1162.43 3.544 1160.63 1.43524 1157 1.43524V1C1160.93 1 1162.89 3.30462 1164.79 5.53089C1166.69 7.76369 1168.49 9.87027 1172.12 9.87027C1175.76 9.87027 1177.56 7.76152 1179.46 5.53089C1181.36 3.30244 1183.32 1 1187.25 1C1191.17 1 1193.14 3.30462 1195.04 5.53089C1196.94 7.76369 1198.74 9.87027 1202.37 9.87027C1206.01 9.87027 1207.81 7.76152 1209.71 5.53089C1211.61 3.30244 1213.57 1 1217.5 1C1221.42 1 1223.39 3.30462 1225.29 5.53089C1227.19 7.76369 1228.99 9.87027 1232.62 9.87027C1236.26 9.87027 1238.05 7.76152 1239.96 5.53089C1241.86 3.30244 1243.82 1 1247.75 1C1251.68 1 1253.64 3.30462 1255.54 5.53089C1257.44 7.76369 1259.24 9.87027 1262.87 9.87027C1266.51 9.87027 1268.31 7.76152 1270.21 5.53089C1272.11 3.30244 1274.07 1 1278 1V1.43524C1274.37 1.43524 1272.57 3.544 1270.66 5.77463C1268.76 8.00308 1266.8 10.3077 1262.87 10.3077Z"
      fill="#FFF8EF"
      stroke="white"
      stroke-width="1.5"
    />
  </svg>
)

export const Menu = ({ className }: SvgProps) => (
  <svg
    className={cx('block', className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Menu">
      <path
        id="icon/navigation/menu_24px"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C3.45 8 3 7.55 3 7C3 6.45 3.45 6 4 6H20C20.55 6 21 6.45 21 7C21 7.55 20.55 8 20 8H4ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18Z"
        fill="white"
      />
    </g>
  </svg>
)

